export default "__VITE_ASSET__D$Z$GIFT__"